import React from "react";
import { ConsentContext } from "./layout.js";
import { useLocation } from "@reach/router";
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";

const GoogleTagManager = () => {
  const [hasLoaded, setHasLoaded] = React.useState(false);
  const { consent } = React.useContext(ConsentContext);
  const location = useLocation();

  if (!hasLoaded && consent.googleTagManager && location) {
    initializeAndTrack(location);
    setHasLoaded(true);
  }

  return null;
};

export default GoogleTagManager;
